import React, { useState } from "react";

const SaleSheetContext = React.createContext({
    saleSheetData: {},
    setCustomerName: (customName) => { },
    setEmail: (email) => { },
    setCountry: (country) => { },
});

export const SaleSheetContextProvider = (props) => {
    const [saleSheetData, setSaleSheetData] = useState({
        customerName: "",
        email: "",
        country: "",
    });

    const handleSetCustomerName = (customerName) => {
        setSaleSheetData({ ...saleSheetData, customerName: customerName });
    };

    const handleSetEmail = (email) => {
        setSaleSheetData({ ...saleSheetData, email: email });
    };

    const handleSetCountry = (country) => {
        setSaleSheetData({ ...saleSheetData, country: country });
    };

    return (
        <SaleSheetContext.Provider value={
            {
                saleSheetData: saleSheetData,
                setCustomerName: handleSetCustomerName,
                setEmail: handleSetEmail,
                setCountry: handleSetCountry,
            }
        }>
            {props.children}
        </SaleSheetContext.Provider>
    );
};

export default SaleSheetContext;